import {
    type CreateSystemLocaleResponseType,
    type CreateSystemLocaleRequestType
} from "./type";
import {
    request
} from "../request";

const createSystemLocale = async (params: CreateSystemLocaleRequestType): Promise<CreateSystemLocaleResponseType> => {
    return await request<CreateSystemLocaleResponseType>("/systemLocale/createSystemLocale", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default createSystemLocale;
